export const statusName = {
    available: 'available',
    break: 'break',
    followUp: 'follow_up',
    inbound: 'inbound',
    intake: 'intake',
    meeting: 'meeting',
    online: 'online',
    pause: 'pause',
    working: 'working'
};
